import { BASE_API_URL } from 'services/api/index';

export const namespaceEndpoint = `${BASE_API_URL}/signup/checknamespace/`;
export const getNamespaceIsValid = (namespace) => `${namespaceEndpoint}?namespace=${namespace}`;
